const Dumbbell2 = ({props}) => (
  <svg
    viewBox="0 0 512 512"
    width="30px"
    height="30px"
    fill="#ffffff"
    {...props}
  >
    <path d="M398.915,216.061l1.356,0.789c-9.915-14.359-16.811-20.94-11.873-39.874 c5.268-20.183,36.4-59.918,6.432-113.417C361.725,4.469,289.271-0.106,256.347,0.002C223.423-0.106,150.972,4.469,117.863,63.56 c-29.967,53.498,1.165,93.234,6.433,113.417c4.938,18.934-1.954,25.515-11.873,39.874l0.057-0.031 c-25.542,31.124-40.866,70.707-40.866,113.815C71.614,430.803,154.175,512,256.002,512c101.839,0,184.384-81.196,184.384-181.365 C440.386,287.175,424.832,247.301,398.915,216.061z M144.148,337.055c-2.034-7.501-3.218-15.316-3.218-23.423 c0-50.663,42.181-91.87,94.027-91.87c7.536,0,14.838,0.965,21.864,2.613L144.148,337.055z M296.301,153.668 c-12.976-2.843-26.45-4.399-40.3-4.399c-13.788,0-27.212,1.54-40.138,4.368c-31.492-2.996-61.328-38.373-47.038-65.918 c14.907-28.756,47.869-41.445,87.38-41.322h0.284c39.51-0.122,72.477,12.566,87.384,41.322 C358.239,115.418,327.989,151.025,296.301,153.668z" />
  </svg>
);

export default Dumbbell2;
